import { createFileRoute } from "@tanstack/react-router";

import { Page } from "../components/site";
import { SITE } from "../lib/seo-data";

export const Route = createFileRoute("/contact")({
  head: () => ({
    meta: [
      { title: "Contact | offerto" },
      {
        name: "description",
        content:
          "Vragen over je offerteaanvraag of je aanmelding als elektricien? Neem contact op met offerto.",
      },
      { property: "og:title", content: "Contact | offerto" },
      {
        property: "og:description",
        content: "Vragen over een offerteaanvraag of aanmelding? Neem contact met ons op.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: `${SITE}/contact` },
      { property: "og:locale", content: "nl_NL" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: `${SITE}/contact` }],
  }),
  component: Contact,
});

function Contact() {
  return (
    <Page
      title="Contact"
      intro="Heb je een vraag over je aanvraag, een ontvangen offerte of over samenwerken? We horen graag van je."
    >
      <div className="mt-12 grid gap-6 md:grid-cols-2">
        <div className="rounded-lg border border-border bg-card p-6">
          <h2 className="text-lg font-bold">Klantenservice</h2>
          <p className="mt-2 text-sm text-muted-foreground">
            Bereikbaar op werkdagen van 09:00 tot 17:00.
          </p>
          <p className="mt-4 text-sm">
            E-mail: <span className="font-semibold">info@elvion-group.nl</span>
          </p>

        </div>
        <div className="rounded-lg border border-border bg-card p-6">
          <h2 className="text-lg font-bold">Voor elektriciens</h2>
          <p className="mt-2 text-sm text-muted-foreground">
            Wil je aanvragen ontvangen uit jouw werkgebied? Meld je aan en we nemen contact op.
          </p>
          <a
            href="/aanmelden"
            className="mt-4 inline-block rounded-lg bg-accent px-5 py-2 text-sm font-semibold text-accent-foreground transition-colors hover:bg-accent-hover"
          >
            Aanmelden als elektricien
          </a>
        </div>
      </div>
    </Page>
  );
}
